
export default {
  props: {
    article: Object,
    share: Array,
  },
  methods: {
    getTimeStamp(date) {
      return new Date(date).toISOString().split("T")[0];
    },
  },
};
